window.Tag = {
	
	edit: function(tagid){
		
		if(undefined == tagid) {
			return true;
		}

		var options = {
			title	: Loc.g("Modification d'un Smart Tag"),
			buttons	:[
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"), 
					click : function(){
						$("#tagEditForm").submit();
					}
				}
			], 
			callback	: function(){Tag.prepareEditForm();}
		};
		
		MyWindow.load("tags", {'do':"tagForm", 'tagid':tagid}, options);
		
	},
	
	prepareEditForm : function(){
		
		var formId = "tagEditForm";
		var options = {success:function(data){Tag.recordEditCallback(data);}, dataType:"json"};
		var params = {'do': 'updateTag'};
		MyForm.prepare(formId, "tags&"+$.param(params), options, true);
		MyFacture.initEvent();		
		
	},
	
	recordEditCallback : function(data){
		var formIsOk = MyForm.processJson(data, "tagEditForm");
		if(formIsOk){
			Utils.reload();
		}
	},
	
	confirmDelete : function(tagid){
		
		if (tagid == undefined){
			return true;
		}

		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'un Smart Tag"),
			buttons		: [
				{
					text	: Loc.g("Annuler"),
					click	: function(){$(this).dialog("close");}
				},
                {
                    text	: Loc.g("Valider"),
                    click	: function(){
                        $('body').data('temp_delete_tag', $(this));
                        $.ajax({
                            url: "/?_f=tags",
                            data: {
                                'do': 'doDeleteTag',
                                'tag_id': tagid
                            }
                        }).done(function() {
                            $('body').data('temp_delete_tag').dialog("close");
                            Listing.update('tagsListing');
                        });
                    }
                }
            ]
		};

		MyWindow.alert(Loc.g('Etes-vous sûr de supprimer ce mot-clé, il disparaîtra de tous les objets auquel il était lié. Continuer ?'), options);
	},
	
	deleteCallback : function(data){
		
		var formIsOk = MyForm.processJson(data, "tagDeleteForm");
		if(formIsOk){
			Utils.reload();
		}
		
	},
	
	prepareFilterForm: function(){
		
        var options = {success:function(data){Tag.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("tagsFilterForm", "tags&do=updateListing", options);
		
    },
	
	processFilterForm: function(data){
		Listing.refresh("tagsListing", data, data.tags_metadatas);
	},
	
	buildPagenum: function(pagenum, nbpage){},

	massEditForm: function(linkedtype, linkedids){

		var options = {
			title	: Loc.g("Modification des Smart Tags sur tous les éléments sélectionnés"),
			width : 500,
			buttons	: [
				{
					text : Loc.g("Annuler"), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"), 
					'class' : 'btn btn-primary',
					click : function(){
						$("#massTagsForm").submit();
						$(this).dialog("close");
					}
				}
			],
			callback	: function(){
				Tag.prepareTagsForm('recordMassTagsForm', 'massTagsForm');
			}
		};
		
		var params = {
			action:"massTagsForm", 
			linkedtype: linkedtype, 
			linkedids: linkedids
		};
		
		MyWindow.load("tags&do=massTagsForm", params, options);
	},

	prepareTagsForm: function(action, formid){
		MyFacture.customForm();
		
		var options = {
			success: function (data) {
				if (data.form.status === 'failed') {
					Push.error(data.form.msg + ' ( tag : ' + data.newTag.name + ' )');
				}

				var formIsOk = MyForm.processJson(data, "groupForm");
				if (formIsOk) {
					var opt = {
						title: Loc.g('Tags ajoutés'),
						type: 'confirm',
						buttons: [
							{
								text: Loc.g("Ok"), 
								click: function () {
									$(this).dialog("close");
								}
							}
						],
					};
					MyWindow.alert(Loc.g("Tags ajoutés aux éléments sélectionnées"), opt);
					Utils.reload();
				}
			}, 
			dataType: "json"
		};

		MyForm.prepare(formid, "tags&" + $.param({do: action}), options, true);
	}

};

window.TagEngine = {
	
	prepareEditForm: function(){
		
		var formId = "tagForm";
		var options = {success:function(data){TagEngine.recordEditCallback(data);}, dataType:"json"};
		var params = {'do': 'recordTags'};
		MyForm.prepare(formId, "tags&"+$.param(params), options);
		MyFacture.initEvent();
		
	},
	
	recordEditCallback : function(data){
		
		if (data.tags.length > 0){
			for(var i in data.tags){
				var tag = data.tags[i];
				if(!Utils.exists("tag_"+tag.id)){
					$('.tagsListing ul').append('<li id="tag_'+tag.id+'"><a class="btn btn-primary" href="javascript:;" onclick="TagEngine.deleteTag('+tag.id+');">'+tag.word+'</a></li>');
				}
			}
		}
		
		$('#tagForm').find('#tag_word').val('');
	},
	
	addTag : function(newTag){
		
		var newTagId = null, newTagName = null;
		var linkedtype = $('#tagForm').find('#tag_linkedtype').val();
		var linkedid = $('#tagForm').find('#tag_linkedid').val();
		var datas = {'do':"recordTag", 'tag_linkedtype' : linkedtype, 'tag_linkedid' : linkedid, 'tag_word' : newTag.name, 'tag_id' : newTag.id};

		MyFacture.post("tags", datas, function(data){
			newTagId = 'tag_'+data.tagid;
			newTagName = data.tagname;

			if (data.form.status === 'failed') {
				Push.error(data.form.msg);
				
			} else if (data.newTag) {
				var oldItem = new Object();
				oldItem.id = oldItem.name = data.newTag.name;
				$('#tag_word').tokenInput('insert', data.newTag);
				$('#tag_word').tokenInput('remove', oldItem);
			}
		}, "json");
		
		return newTagId;

	},
	
	deleteTag : function(tagId){
		
		var linkedtype = $('#tagForm').find('#tag_linkedtype').val();
		var linkedid = $('#tagForm').find('#tag_linkedid').val();
		var datas = {'do':"deleteTag", 'tagid': tagId, 'linkedtype' : linkedtype, 'linkedid' : linkedid};
		MyFacture.post("tags", datas, function(data){TagEngine.deleteTagCallback(data)}, "json");
		
		return false;
	},
	
	deleteTagCallback : function(data){
		
		if(data.tagid && Utils.exists("tag_"+data.tagid))
			$("#tag_"+data.tagid).fadeOut('slow', function(){$(this).remove();}
		);

	},
	
	init : function(){
		TagEngine.prepareEditForm();
	}
	
};